class WristStrapBlock {
  constructor(element) {
    this.element = element;
    this.trigger = element.querySelector('[data-wrist-strap-trigger]');
    this.removeButton = element.querySelector('[data-wrist-strap-remove]');
    this.baseTitle = element.querySelector('[data-wrist-strap-base]');
    this.colorWrapper = element.querySelector('[data-wrist-strap-color-wrapper]');
    this.colorText = element.querySelector('[data-wrist-strap-color]');
    this.image = element.querySelector('.wrist-strap-block__image');
    this.price = element.querySelector('[data-wrist-strap-price]');
    this.chargeInput = element.querySelector('[data-wrist-strap-charge-input]');
    this.idInput = element.querySelector('[data-wrist-strap-id-input]');
    this.colorInput = element.querySelector('[data-wrist-strap-color-input]');
    this.fields = Array.from(element.querySelectorAll('[js-wrist-strap-field]'));
  }

  init() {
    this.trigger?.addEventListener('click', (event) => {
      event.preventDefault();
      document.dispatchEvent(
        new CustomEvent('wrist-strap:open', {
          detail: {
            button: this.trigger,
          },
        }),
      );
    });

    this.removeButton?.addEventListener('click', (event) => {
      event.preventDefault();
      document.dispatchEvent(
        new CustomEvent('wrist-strap:reset', {
          detail: {
            widget: this.element,
          },
        }),
      );
    });
  }
}

const initWristStrapBlocks = () => {
  const blocks = document.querySelectorAll('[data-wrist-strap-widget][data-standalone="true"]');
  blocks.forEach((block) => {
    if (block.dataset.wristStrapBlockInit === 'true') return;
    block.dataset.wristStrapBlockInit = 'true';
    new WristStrapBlock(block).init();
  });
};

document.addEventListener('DOMContentLoaded', initWristStrapBlocks);
document.addEventListener('wrist-strap-block:init', initWristStrapBlocks);
